import React, { useState, useRef, useEffect } from "react";
import { IconButton, Typography } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import { Link } from "react-router-dom";
import Footer from "../../Footer/Footer";
import Header from "../../Header/MegaMenu";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import "owl.carousel"; // Import Owl Carousel AFTER jQuery
import OwlCarousel from "react-owl-carousel";
import '../outterpages.css'
// import curreciesBan from '../../../assets/Images/Outterpage/currencies-banner-img.webp';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from "@mui/material/styles";
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import Stack from '@mui/material/Stack';
import eng from '../../../assets/Images/Outterpage/eng.webp'
import jap from '../../../assets/Images/Outterpage/jap.webp'
import cardimg from '../../../assets/Images/Outterpage/card-1.webp'
import sec4 from '../../../assets/Images/Outterpage/sec-4-img.webp'
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import commoditiesban from '../../../assets/Images/Outterpage/commodities-banner.webp'
import commoditiescta from '../../../assets/Images/Outterpage/cta-commodites.webp'

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    borderBottom: "1px solid  rgba(255, 146, 71, 1)  ",
    '&:nth-of-type(odd)': {
        background: "linear-gradient(90deg,rgba(99, 97, 97, 0.44) 15.1%,rgba(70, 69, 68, 0.49) 85.42%)",
    },
    // Hide the last border of the table
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

// const videos = [
//   { id: 1, src: video1 },
//   { id: 2, src: video2 },
//   { id: 3, src: video3 },
//   { id: 3, src: video4 },
// ];
const testimonials = [
    {
        name: "Sherly",
        position: "CEO",
        text: "Figma ipsum component variant main layer. Library figjam subtract font rotate move auto. Figjam strikethrough bullet text device pen scale. Group horizontal link library flows ellipse flatten library undo.",
    },
    {
        name: "Carlos",
        position: "Product Manager",
        text: "An amazing experience! The support and innovation mindset Rishi brings to the team makes every project more exciting and successful.",
    },
    // {
    //   name: "Rishi",
    //   position: "CEO",
    //   text: "Regulus has truly streamlined my trading activity. The platform is incredibly user-friendly, making it easy to navigate and execute trades quickly. I've seen a noticeable improvement in my efficiency!",
    // },
];

const options = {
    margin: 50,
    items: 1,
    autoplay: true,
    autoplayTimeout: 6000,
    dots: false, // Hide default dots
    loop: true,
    smartSpeed: 800,
    nav: true, // We will use custom navigation
    responsive: {
        0: {
            dots: true,
            nav: false,
        },
        768: {
            dots: false,
            nav: true,
        },
    },
};

const marketData = [
    { id: 1, pair: "GBP/USD", value: "1,355.78", trend: "up" },
    { id: 2, pair: "GBP/USD", value: "1,120.65", trend: "down" },
    { id: 3, pair: "GBP/USD", value: "1,120.65", trend: "down" },
    { id: 4, pair: "GBP/USD", value: "1,355.78", trend: "up" },
    { id: 5, pair: "GBP/USD", value: "1,120.65", trend: "down" },
];


const tableData = [
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },

]
const accordianData = [
    {
        question: "How Can I Calculate the Required Margin for Trading a Commodity?",
        answer: "To calculate the required margin for trading a commodity, use the formula: ",
        answer2: "Margin = Quantity × Price × Margin Requirement",
        panel: "panel1"
    },
    {
        question: "Is it mandatory to register my card before making a deposit?",
        answer: "All commodity CFD markets, including those on MetaTrader, have an expiration date. However, spot commodity markets do not expire. The trading platform displays the upcoming expiry date and time for each CFD market. For detailed information, refer to the Market Information Sheets within the trading platform.",
        answer2: "Upon the expiry of a CFD market, we automatically close all open positions at the latest available prices and cancel any pending orders. To keep positions active, you must manually open a new position in the subsequent contract month.",
        panel: "panel2"
    },


]
const cardset = [
    {

        head: "Zero Commissions",
        para: "Enjoy trading with no fees and access margins as low as 10%."
    },
    {

        head: "Go Long or Short",
        para: "Take advantage of both rising and falling markets when trading commodities."
    },
    {

        head: "Use Leverage",
        para: "Trade with a fraction of the commodity price, understanding that leverage can amplify both profits and losses."
    },
    {

        head: "User-Friendly Platform",
        para: "Finowiz provides an intuitive and easy-to-use platform designed for seamless commodities trading, catering to both beginners and experienced traders."
    },
    {

        head: "Extensive Commodity Options",
        para: "Access a wide range of commodities, including oil, gold, silver, and more, empowering you to diversify your investments based on your preferences and strategies."
    },
    {

        head: "Favorable Trading Conditions",
        para: "Take advantage of favorable conditions including zero commissions, low margin requirements, and the flexibility to capitalize on both upward and downward market movements. Enhance your profitability and trade execution with Finowiz."
    },

]

const Commodities = () => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const lg = useMediaQuery(theme.breakpoints.up("lg"));
    const md900 = useMediaQuery(theme.breakpoints.up("900"));
    const xl = useMediaQuery(theme.breakpoints.up("xl"));
    const md766 = useMediaQuery(theme.breakpoints.up("766"));
    const [expanded, setExpanded] = React.useState('panel1');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };
    return (
        <div className="OutterPage">
            <Header />
            <div className="bg-outer comm-ot-bg">
                <section className="banner outter-banner">
                    <div className="contain-width">
                        <Grid container sx={{ alignItems: "flexStart" }}>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} sx={{ placeContent: "center" }}>
                                <div
                                    className="banner-left "
                                    style={{ height: xl ? "500px" : "auto", placeContent: "center" }}
                                >
                                    {/* <p>Trade Commodities on the global Financial Markets</p> */}
                                    <h1 className="mb-30 mt-10">
                                        Trade <span>Commodities</span> with Finowiz
                                    </h1>
                                    <p>Trade commodities such as metals and energies to explore new market opportunities, protect against inflation, and diversify your investment portfolio effortlessly with Finowiz.</p>
                                    {/* <div
                  className="display-1 btn flex-wrap "
                  style={{ marginBottom: matches ? "40px" : "20px" }}
                >
                  <Link to="/open-new-account" className="bg-btn">
                    Get Started
                  </Link>
                </div> */}
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>

                                <div className="text-center ban-img">
                                    <img width="90%" src={commoditiesban} />
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </section>
                <section className="trade-easy sec-3">
                    <div className="contain-width">
                        <div className="heading">
                            {/* <p>
                                <span>Why Finowiz</span>
                            </p> */}
                            <h2>
                                Why <span>Finowiz?</span>
                            </h2>
                            {/* <p>
                                Figma ipsum component variant main layer. Prototype share asset stroke distribute star create. Rectangle stroke auto figjam project library select.
                            </p> */}
                        </div>
                        <Grid container spacing={5} >
                            {
                                cardset.map((item) => (
                                    <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }} className="why-choose-card mt-10" sx={{ alignItems: !md900 && "center" }}>
                                        <div>
                                            <img src={cardimg} />
                                        </div>
                                        <p className="mt-10 head"><span className="grd">{item.head}</span></p>
                                        <p className="mt-10">{item.para}</p>

                                    </Grid>
                                ))
                            }


                        </Grid>


                    </div>
                </section>
            </div>
            <section className="trade-open section-4 commodities-cta">
                <div className="contain-width">
                    <Grid container spacing={8} sx={{ rowGap: 0, }}>
                        <Grid
                            item
                            size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}
                            className="left-side"
                            sx={{ placeItems: !md766 && "center", textAlign: !md766 && "center" }}
                        >
                            <h3>
                                Trade Popular <span>Commodities</span>
                            </h3>
                            <p>
                                Trade top commodities such as Gold, Oil, Silver, and Natural Gas with Finowiz, the ideal platform for efficient and straightforward commodity trading. Enhance your skills with our extensive educational resources and start your trading journey by opening a live account today!
                            </p>
                            <div className="mt-40">
                                <Link to="#" className="bg-btn">
                                    Register now
                                </Link>
                            </div>
                        </Grid>
                        {/* <Grid
                            item
                            size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}
                            className=""
                        >
                            <div>
                                <img width="100%" src={sec4} />
                            </div>

                        </Grid> */}
                    </Grid>
                </div>
            </section>
         

            <section class="cta-sec2 out-cta">
                <div className="contain-width">
                    <Grid container spacing={8}>
                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <label>Your Partner in Trading Success</label>
                            <h2 >Register Now for Seamless Trading with Finowiz</h2>
                            {/* <p>
                            Learn to trade without using real money, refining your
                            strategies and learning from mistakes.
                          </p> */}
                            <Link to="#" className="brd-btn" >
                                Register Now
                            </Link>
                        </Grid>
                    </Grid>
                </div>
            </section>



            <Footer />
        </div>
    );
};

export default Commodities;
